import styled from "styled-components";

export const InputError = styled.span`
  color: #ff4d4f;
`;
